import React, { useState, memo, useEffect, useRef } from "react";
import { Card, Col, List, Row, Skeleton, Slider, Space, Spin } from "antd";
import Meta from "antd/es/card/Meta";

import {
    DropDown,
    InputField,
    SearchInput,
    SubmitButton,
    TextComponent,
} from "../../../../components";
import styles from "./MusicList.module.css";
import dummyImg from "../../../../assets/dummy.jpg";
import { AiFillDelete, AiFillStar, AiFillYoutube, AiFillPlusCircle, AiOutlineArrowRight, AiFillCheckSquare, AiOutlineBorder } from "react-icons/ai";
import { BsSpotify } from "react-icons/bs";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PlaylistMiddleware } from "../../../../Store/Middlewares/PlaylistMiddleware";
import Modal from "../../../../components/modal/Modal";
import { BiPlayCircle } from "react-icons/bi";
import { redirectToSpotifyAuth } from './../../../../utills/spotifyAuth';
import Storage from "../../../../utills/AsyncStorage";
import { redirect_uri, redirectURI } from "../../../../utills";


const RenderItem = memo(({ item, loader }) => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const openYouTubeVideo = (videoId) => {
        window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
    };
    return (
        <List.Item
        // onClick={() => {
        //     openYouTubeVideo(item?.video_id);
        // }}
        >
            {loader ? (
                <Space
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        marginTop: "10px",
                    }}
                >
                    <Skeleton.Image active className={styles.image} />
                    <Skeleton.Input active size={20} />
                </Space>
            ) : (
                <Card
                    hoverable
                    style={{ width: "100%", textAlign: "center", alignItems: "center" }}
                    cover={
                        <img
                            className={styles.image}
                            src={item.image ? item.image : dummyImg}
                            alt="example"
                            resizeMode="contain"
                        />
                    }
                >
                    <Meta
                        style={{ textAlign: "center" }}
                        title={
                            <>
                                <TextComponent
                                    text={item?.name}
                                // textClass={styles.nameText}
                                />
                            </>
                        }
                        description={<TextComponent text={item.description} />}
                    />

                    <Col className={styles.addSongModal}>
                        <div onClick={() => { dispatch(PlaylistMiddleware.deleteSongs({ id: item.id })) }} className={styles.addSongModalDiv}>
                            <AiFillDelete color="#00000" size={30} />

                        </div>
                        <div onClick={() => { openYouTubeVideo(item?.video_id); }} className={styles.addSongModalDiv}>
                            <BiPlayCircle color="#00000" size={30} />
                        </div>

                    </Col>
                </Card>
            )}
        </List.Item>
    );
});
const RenderYoutubeItem = memo(({ item, loader }) => {
    console.log('============RenderYoutubeItem item', item);
    const dispatch = useDispatch();
    const { state } = useLocation();
    const Playlist = useSelector(
        state => state.PlaylistReducer?.SongsList,
    );

    let find = Playlist.find((it) => it?.video_id == item?.id?.videoId)
    const [isAdd, setisAdd] = useState(false)

    const addYoutubeSong = (item) => {
        setisAdd(item?.id?.videoId)
        dispatch(PlaylistMiddleware.addSongs({ play_list_id: state?.data?.id, name: item?.snippet?.title, image: item?.snippet?.thumbnails?.default?.url, description: item?.snippet?.description, type: 'youtube', video_id: item?.id?.videoId })).then(() => {
            setisAdd(null)
        }).catch(() => setisAdd(null))
    }
    const openYouTubeVideo = (videoId) => {
        window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
    };
    return (
        <List.Item
        >
            {loader ? (
                <Space
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        marginTop: "10px",
                    }}
                >
                    <Skeleton.Image active className={styles.image} />
                    <Skeleton.Input active size={20} />
                </Space>
            ) : (
                <Card
                    hoverable
                    style={{ width: "100%", textAlign: "center", alignItems: "center" }}
                    cover={
                        <img
                            className={styles.image}
                            src={item?.snippet?.thumbnails?.default?.url ? item?.snippet?.thumbnails?.default?.url : dummyImg}
                            alt="example"
                            resizeMode="contain"
                        />
                    }
                >
                    <Meta
                        style={{ textAlign: "center" }}
                        title={
                            <>
                                <TextComponent
                                    text={item?.snippet?.title ? item?.snippet?.title : '--'}
                                    textClass={styles.songsText}
                                />
                            </>
                        }
                    // description={<TextComponent text={item.description} />}
                    />

                    {isAdd == item?.id?.videoId ? <Spin size="large" /> :
                        !find &&
                        <Col className={styles.addSongModal}>
                            <div onClick={() => { addYoutubeSong(item) }} className={styles.addSongModalDiv}>
                                <AiFillPlusCircle color="#00000" size={20} />

                            </div>
                            <div onClick={() => { openYouTubeVideo(item?.id?.videoId); }} className={styles.addSongModalDiv}>
                                <BiPlayCircle color="#00000" size={30} />
                            </div>

                        </Col>

                    }
                </Card>
            )}
        </List.Item>
    );
});


const MusicList = () => {
    const { state } = useLocation();
    const [search, setSearch] = useState("");
    const [loader, setLoader] = useState(false);
    const Playlist = useSelector(
        state => state.PlaylistReducer?.SongsList,
    );
    const user = useSelector(state => state.AuthReducer.user);

    const [addSongModal, setaddSongModal] = useState(false);
    const [searchYoutubeModal, setsearchYoutubeModal] = useState(false);
    const [YoutubeSongs, setYoutubeSongs] = useState([])
    const [title, setTitle] = useState('');
    const [isSearch, setisSearch] = useState(false)
    let timeOut = useRef(null);
    const dispatch = useDispatch();
    const token = localStorage.getItem('access_token');
    const [isSpotify, setisSpotify] = useState(false)
    const [spotifyPlaylist, setSpotifyPlaylist] = useState([])
    const [spotifysongsModal, setSpotifySongsModal] = useState(false)
    const [spotifysongs, setSpotifySongs] = useState([])
    const [isAdd, setisAdd] = useState(null)

    const [SelectedPlaylist, setSelectedPlaylist] = useState([])
    const [isMultiselect, setisMultiselect] = useState(false)
    const [isUpload, setisUpload] = useState(false)


    const getData = (data = null) => {
        setLoader(true);
        dispatch(PlaylistMiddleware.getSongs({ id: state?.data?.id }))
            .then(() => {
                setLoader(false);
            })
            .catch(() => {
                setLoader(false);
            });
    };
    useEffect(() => {
        getData()
    }, []);


    const SearchYoutube = (val) => {
        setTitle(val)
        setisSearch(true)
        clearTimeout(timeOut.current)
        timeOut.current = setTimeout(() => {
            if (val) {
                dispatch(PlaylistMiddleware.getYoutubeSongs({ name: val })).then((data) => {
                    setisSearch(false)
                    if (val) {
                        setYoutubeSongs(data?.items)
                    } else {
                        setYoutubeSongs([])
                    }

                }).catch(() => setisSearch(false))
            } else {
                setYoutubeSongs([])
                setisSearch(false)
            }
        }, 1500);

    }

    const connectSpotify = async () => {
        if (!token) {
            redirectToSpotifyAuth();
            return;
        } else {
            const isTokenExpired = () => {
                const expiresAt = localStorage.getItem("expires_at");
                return !expiresAt || Date.now() > parseInt(expiresAt);
            };
            if (isTokenExpired()) {
                const refreshToken = localStorage.getItem("refresh_token");
                const response = await fetch("https://accounts.spotify.com/api/token", {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: new URLSearchParams({
                        grant_type: "refresh_token",
                        refresh_token: refreshToken,
                        client_id: "cbd536439be2450aa0709cb1c39ffcba",
                    }),
                });

                const data = await response.json();
                const expiresIn = data.expires_in; // usually 3600 seconds
                const expiresAt = Date.now() + expiresIn * 1000;

                localStorage.setItem("refresh_token", data.refresh_token);
                localStorage.setItem("expires_at", expiresAt);
                localStorage.setItem("access_token", data.access_token);
                getPlaylist()
                // token expired — refresh it or ask user to re-login
            } else {
                // safe to use token
                getPlaylist()
            }

        }

    };

    const getPlaylist = () => {
        dispatch(PlaylistMiddleware.getSpotifyPlaylist({})).then((data) => {
            setaddSongModal(false)
            setSpotifyPlaylist(data?.items)
            setisSpotify(true)
        }).catch(() => setisSpotify(true))
    }

    const getPlaylistSongs = (id) => {
        setisSpotify(false)
        setisAdd(id)
        dispatch(PlaylistMiddleware.getSpotifyPlaylistSongs({ id })).then((data) => {
            setSpotifySongs(data?.items)
            setSpotifySongsModal(true)
            setisAdd(null)
        })
    }

    const searchSong = (item) => {
        setisAdd(item.track.id)
        const trackName = item?.track?.name;
        const artistNames = item?.track.artists.map(a => a.name).join(' ');
        const youtubeSearchQuery = `${trackName} ${artistNames} ${item?.track?.external_ids?.isrc}`;
        dispatch(PlaylistMiddleware.getYoutubeSongs({ name: youtubeSearchQuery })).then((data) => {
            addSpotifySong(data.items[0])
        })

    }

    const addSpotifySong = (item) => {
        dispatch(PlaylistMiddleware.addSongs({ play_list_id: state?.data?.id, name: item?.snippet?.title, image: item?.snippet?.thumbnails?.default?.url, description: item?.snippet?.description, type: 'youtube', video_id: item?.id?.videoId })).then(() => {
            setisAdd(null)
        }).catch(() => setisAdd(null))
    }

    const uploadBulkSongs = () => {
        if (SelectedPlaylist.length > 0) {
            setisUpload(true)
            dispatch(PlaylistMiddleware.uploadBulkPlaylistSongs({ Queries: SelectedPlaylist, id: state?.data?.id })).then((data) => {
                setisUpload(false)
                setisSpotify(false)
                setisMultiselect(false)
                setSpotifySongsModal(false)
                setSpotifySongs([])
            })
        }
    }

    const renderSpotifyPlaylists = (item) => {

        return (
            <List.Item
            >
                {loader ? (
                    <Space
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            marginTop: "10px",
                        }}
                    >
                        <Skeleton.Image active className={styles.image} />
                        <Skeleton.Input active size={20} />
                    </Space>
                ) : (
                    <Card
                        onClick={() => getPlaylistSongs(item?.id)}
                        hoverable
                        style={{ width: "100%", textAlign: "center", alignItems: "center" }}
                        cover={
                            <img
                                className={styles.image}
                                src={item?.images?.length > 0 ? item?.images[0].url : dummyImg}
                                alt="example"
                                resizeMode="contain"
                            />
                        }
                    >
                        <Meta
                            style={{ textAlign: "center" }}
                            title={
                                <>
                                    <TextComponent
                                        text={item.name ? item.name : '--'}
                                        textClass={styles.songsText}
                                    />
                                </>
                            }
                        // description={<TextComponent text={item.description} />}
                        />

                        {isAdd == item?.id ? <Spin size="large" /> :
                            <Col className={styles.addSongModal}>
                                <div className={styles.addSongModalDiv}>
                                    <AiOutlineArrowRight color="#00000" size={20} />
                                </div>
                            </Col>

                        }
                    </Card>
                )}
            </List.Item>
        );
    }
    const renderSpotifySongs = (item) => {
        let find = Playlist.find((it) => it?.name.includes(item?.track?.name))
        let FindMulti = SelectedPlaylist.find(it => it?.track?.id == item?.track?.id)


        return (
            <List.Item
            >
                {/* {loader ? (
                    <Space
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            marginTop: "10px",
                        }}
                    >
                        <Skeleton.Image active className={styles.image} />
                        <Skeleton.Input active size={20} />
                    </Space>
                ) : ( */}
                    <Card
                        hoverable
                        style={{ width: "100%", textAlign: "center", alignItems: "center" }}
                        cover={
                            <img
                                className={styles.image}
                                src={item?.track?.album?.images?.length > 0 ? item?.track?.album?.images[0].url : dummyImg}
                                alt="example"
                                resizeMode="contain"
                            />
                        }
                    >
                        <Meta
                            style={{ textAlign: "center" }}
                            title={
                                <>
                                    <TextComponent
                                        text={item?.track?.name ? item?.track?.name : '--'}
                                        textClass={styles.songsText}
                                    />
                                </>
                            }
                            description={<TextComponent text={item?.track.artists.map(a => a.name).join(', ')}
                                textClass={styles.songsText} />}
                        />
                        {isAdd == item.track.id ? <Spin size="large" /> :
                            !find && !isMultiselect &&
                            <Col className={styles.addSongModal}>
                                <div onClick={() => searchSong(item)} className={styles.addSongModalDiv}>
                                    <AiFillPlusCircle color="#00000" size={20} />
                                </div>
                            </Col>

                        }
                        {/* {isUpload && <> */}
                        {isMultiselect && !find &&
                            <div
                                // disabled={isUpload}
                                onClick={() => {
                                    if (FindMulti) {
                                        let data = [...SelectedPlaylist]
                                        let index = data.findIndex(it => it?.track?.id == item?.track?.id)
                                        data.splice(index, 1)
                                        setSelectedPlaylist(data)
                                    } else {
                                        let data = [...SelectedPlaylist]
                                        data.push(item)
                                        setSelectedPlaylist(data)
                                    }
                                }}
                            >
                                {FindMulti ?
                                    <AiFillCheckSquare color="#00000" size={20} />
                                    :
                                    <AiOutlineBorder color="#00000" size={20} />}
                            </div>
                        }
                        {/* </>} */}
                    </Card>
                {/* )} */}
            </List.Item>
        );
    }


    return (
        <>
            {state?.data?.vendor_id == user?.id &&
                <SubmitButton
                    title={'Add Songs'}
                    onClick={() => setaddSongModal(true)}
                />
            }
            <List
                className={styles.listClass}
                grid={{
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 3,
                    xl: 4,
                    xxl: 4,
                }}
                dataSource={Playlist}
                renderItem={(item) => <RenderItem item={item} loader={loader} />}
                footer={
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {/* {findVendorsPaginationByCat?.links?.next != null ? (
                            <div style={{ width: "50%" }}>
                                <SubmitButton title={"Load More"} onClick={onLoadMore} />
                            </div>
                        ) : null} */}
                    </div>
                }
            />
            <Modal
                isModalOpen={addSongModal}
                setIsModalOpen={setaddSongModal}
                closable={true}
                className={styles.modal}
            >
                <div className={styles.modalCon}>
                    <TextComponent
                        text={"Add Songs Via"}
                        textClass={styles.modalHeading}
                    />
                    <Space
                        direction="vertical"
                        size="small"
                        style={{
                            display: "flex",
                            marginTop: "10px",
                        }}
                    >
                        <Col className={styles.addSongModal}>
                            <div onClick={() => { setaddSongModal(false); setsearchYoutubeModal(true) }} className={styles.addSongModalDiv}>
                                <AiFillYoutube color="#00000" size={70} />
                                <TextComponent
                                    text={"Youtube"}
                                    textClass={styles.nameText}
                                />
                            </div>
                            <div onClick={() => { connectSpotify() }} className={styles.addSongModalDiv}>
                                <BsSpotify color="#00000" size={70} />
                                <TextComponent
                                    text={"Spotify"}
                                    textClass={styles.nameText}
                                />
                            </div>

                        </Col>
                    </Space>
                </div>
            </Modal>
            <Modal
                isModalOpen={searchYoutubeModal}
                setIsModalOpen={setsearchYoutubeModal}
                closable={true}
                className={styles.youtubeModal}
            >
                <div className={styles.modalCon}>
                    <TextComponent
                        text={"Search Songs on Youtube"}
                        textClass={styles.modalHeading}
                    />
                    <Space
                        direction="vertical"
                        size="small"
                        style={{
                            display: "flex",
                            marginTop: "10px",
                        }}
                    >
                        <SearchInput
                            className={styles.searchInput}
                            placeholder={"Search Song"}
                            onChange={(e) => SearchYoutube(e.target.value)}
                            value={title}
                        />

                        <List
                            className={styles.listClass}
                            grid={{
                                xs: 1,
                                sm: 2,
                                md: 2,
                                lg: 3,
                                xl: 4,
                                xxl: 4,
                            }}
                            dataSource={YoutubeSongs}
                            renderItem={(item) => <RenderYoutubeItem item={item} loader={loader} />}

                        />

                        <SubmitButton
                            title={'Done'}
                            onClick={() => { setsearchYoutubeModal(false); setYoutubeSongs([]); setTitle('') }}
                            style={styles.add_temp_button}
                        />

                    </Space>
                </div>
            </Modal>
            <Modal
                isModalOpen={isSpotify}
                setIsModalOpen={setisSpotify}
                closable={true}
                className={styles.youtubeModal}
            >
                <div className={styles.modalCon}>
                    <TextComponent
                        text={"Spotify Playlists"}
                        textClass={styles.modalHeading}
                    />
                    <Space
                        direction="vertical"
                        size="small"
                        style={{
                            display: "flex",
                            marginTop: "10px",
                        }}
                    >

                        <List
                            className={styles.listClass}
                            grid={{
                                xs: 1,
                                sm: 2,
                                md: 2,
                                lg: 3,
                                xl: 4,
                                xxl: 4,
                            }}
                            dataSource={spotifyPlaylist}
                            renderItem={renderSpotifyPlaylists}

                        />

                        <SubmitButton
                            title={'Done'}
                            onClick={() => { setisSpotify(false); setSpotifyPlaylist([]) }}
                            style={styles.add_temp_button}
                        />

                    </Space>
                </div>
            </Modal>
            <Modal
                isModalOpen={spotifysongsModal}
                setIsModalOpen={setSpotifySongsModal}
                closable={true}
                className={styles.youtubeModal}
            >
                <div className={styles.modalCon}>
                    <TextComponent
                        text={"Spotify Songs"}
                        textClass={styles.modalHeading}
                    />
                    <Space
                        direction="vertical"
                        size="small"
                        style={{
                            display: "flex",
                            marginTop: "10px",
                        }}
                    >
                        <div
                            // disabled={isUpload}
                            // style={{ width: 20, height: 20, marginRight: 11, margin: 5 }}
                            onClick={() => {
                                setisMultiselect(!isMultiselect)
                                if (!isMultiselect) {
                                    setSelectedPlaylist(spotifysongs)
                                } else {
                                    setSelectedPlaylist([])
                                }
                            }}
                        >
                            <TextComponent
                                text={"Select All"}
                                textClass={styles.smallText}
                            />
                            {isMultiselect ?
                                <AiFillCheckSquare color="#00000" size={20} />
                                :
                                <AiOutlineBorder color="#00000" size={20} />
                            }
                        </div>


                        <List
                            className={styles.listClass}
                            grid={{
                                xs: 1,
                                sm: 2,
                                md: 2,
                                lg: 3,
                                xl: 4,
                                xxl: 4,
                            }}
                            dataSource={spotifysongs}
                            renderItem={renderSpotifySongs}

                        />
                        {isUpload ? <Spin size="large" /> :
                            isMultiselect &&
                            <SubmitButton
                                title={'Done'}
                                onClick={uploadBulkSongs}
                                style={styles.add_temp_button}
                            />
                            // <Button
                            //     disabled={SelectedPlaylist.length > 0 ? false : true}
                            //     onPress={uploadBulkSongs}
                            //     title={'Upload'}
                            //     style={{ ...styles.button, marginVertical: 10, marginTop: 10, opacity: SelectedPlaylist.length > 0 ? 1 : 0.5 }}
                            // />
                        }

                        {/* <SubmitButton
                            title={'Done'}
                            onClick={() => { setSpotifySongsModal(false); setSpotifySongs([]) }}
                            style={styles.add_temp_button}
                        /> */}

                    </Space>
                </div>
            </Modal>
        </>
    );
};

export default MusicList;
